export default "__VITE_ASSET__BTksu870__"